import React from 'react';
import ReactDOM from 'react-dom';
import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';
import App from './App';

import { connector } from './connector/index';

(async () => {
  await connector();

  ReactDOM.render(
    <React.StrictMode>
      <RecoilRoot>
        <RecoilNexus />
        <App />
      </RecoilRoot>
    </React.StrictMode>,
    document.getElementById('root')
  );
})();
